<template>
  <div
    data-slot="alert-dialog-header"
    :class="cn('tw:flex tw:flex-col tw:gap-2 tw:text-center tw:sm:text-left', props.class)"
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shared/utilities/classes';

const props = defineProps({
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>
